(function($, App, Utils, Components, Pages, Backoffice) {
  'use strict';

  var Log = new Logger("Main");
  Log.l('App defined as follow:', App);
  Log.l('---------------------------');

  App.init = function() {

    Utils._init();

    Components._init();

    Pages._init();
    
    Backoffice._init();

    setTimeout(function() {
      Log.i("Ready, triggering: ", App.Events.Ready);
      App.trigger(App.Events.Ready);
      Log.i("App is up and running!");
    }, 0);

    App.Window.on("unload", function() {
      Utils._destroy();
      Components._destroy();
    });

    // foundation init
    App.Document.foundation();
    $("a[href^='http://'], a[href^='https://']").attr("target","_blank");

  };

  App.Events = {
    Ready: 'app:ready'
  };

  // Auto-Load in case of <body data-fe-auto-load="" ...>
  $('body[data-fe-auto-load]').length && App.init();

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components,
  window.App.Pages,
  window.App.Backoffice
);
